import { UPDATE_EMAIL_CONFIRMATION_SETTINGS } from '../../../modules/actions'

const initialState = {
  email: '',
}

// Action handler
export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EMAIL_CONFIRMATION_SETTINGS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export const updateEmailConfirmationSettings = (payload) => ({
  type: UPDATE_EMAIL_CONFIRMATION_SETTINGS,
  payload
})



// WEBPACK FOOTER //
// ./src/routes/emailConfirmation/modules/emailConfirmation.js